// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function IsPremiumLabel(Props) {
  return React.createElement("div", {
              className: "isPremium-label"
            }, "Premium");
}

var make = IsPremiumLabel;

export {
  make ,
  
}
/* react Not a pure module */
